<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="25"
        viewBox="0 0 21 25"
    >
        <g id="icon_menu_record" transform="translate(0 0)">
            <path
                id="Subtraction_39"
                data-name="Subtraction 39"
                d="M1302.871-6608.128v0a2.993,2.993,0,0,0,.128-.87v-16a3,3,0,0,0-3-3h-12a3.011,3.011,0,0,0-.871.129A2.983,2.983,0,0,1,1290-6630h12a3,3,0,0,1,3,3v16a3.021,3.021,0,0,1-2.127,2.871Z"
                transform="translate(-1284 6630)"
                fill="#fff"
            />
            <path
                id="Subtraction_40"
                data-name="Subtraction 40"
                d="M1299-6606h-12a3,3,0,0,1-3-3v-16a3,3,0,0,1,3-3h12a3,3,0,0,1,3,3v16A3,3,0,0,1,1299-6606Zm-12-8a1,1,0,0,0-1,1,1,1,0,0,0,1,1h6a1,1,0,0,0,1-1,1,1,0,0,0-1-1Zm0-5a1,1,0,0,0-1,1,1,1,0,0,0,1,1h12a1,1,0,0,0,1-1,1,1,0,0,0-1-1Zm0-5a1,1,0,0,0-1,1,1,1,0,0,0,1,1h12a1,1,0,0,0,1-1,1,1,0,0,0-1-1Z"
                transform="translate(-1284 6631)"
                fill="#fff"
            />
        </g>
    </svg>
</template>
